var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pullRefresh",staticClass:"pull-refresh",style:(_vm.boxStyle),attrs:{"id":_vm.flagId},on:{"scroll":_vm.onScroll}},[_c('div',{ref:"pullRefreshLoading",staticClass:"pull-refresh__loading"},[_c('span')]),_c('div',{ref:"pullRefreshContainer",staticClass:"pull-refresh__container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }